// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-show-recent-trips[data-v-15de5237] {\n  width: 100%;\n  overflow: auto;\n}\n.z-3[data-v-15de5237] {\n  z-index: 3;\n}\n.z-2[data-v-15de5237] {\n  z-index: 2;\n}", ""]);
// Exports
module.exports = exports;
